
import { TypeIdentification, Relationship, Gender } from "../../store/medicalAppointment/types";
import { TableType } from "../../store/medicalAppointment/types";
import moment from 'moment';
export const ConvertValueParameter= (valor: TableType | undefined | string): string => {

        let value = valor !== null && valor !== undefined ? valor : "";

        let valueTransform: string ="";

        if(value!==null){
            if (value instanceof Date ) {
                valueTransform = moment(value).format("DD/MM/YYYY");
            }
            else {
                switch (value) {
                    case TypeIdentification.IdentificationCard:
                           valueTransform = TypeIdentification.Value_IdentificationCard;
                        break;
                    case TypeIdentification.Passport:
                           valueTransform = TypeIdentification.Value_Passport;
                        break;
                    case Relationship.Conyuge:
                           valueTransform = Relationship.Value_Conyuge;
                        break;
                        case Relationship.Hijos:
                           valueTransform = Relationship.Value_Hijos;
                        break;
                    case Gender.Male:
                           valueTransform = Gender.Value_Male;
                        break;
                     case Gender.Female:
                           valueTransform = Gender.Value_Female;
                        break;
                    default:
                           valueTransform = value.toString();
                        break;
                }
            }
        }
        return valueTransform;
    }

export const ConvertValueRelationship = (valor: string): string => {
        let valueTransform: string ="";
        switch (valor) {
            case Relationship.Conyuge:
                    valueTransform = Relationship.Value_Conyuge;
                break;
            case Relationship.Hijos:
                    valueTransform = Relationship.Value_Hijos;
                break;
            case Relationship.Titular:
                    valueTransform = Relationship.Value_Titular;
                break;
            default:
                    valueTransform = valor.toString();
                break;
        }
        return valueTransform;
    }
